import { get_key_from_path } from './urls';

export const landing_event = (iframe, app) => {
  let traffic_event = '';
  if (iframe === 'true') {
    traffic_event += 'in_iframe.';
  } else {
    traffic_event += 'sso_landing.';
  }

  const formatted_app = app ? app.replace(/\./g, '_') : 'sso';
  traffic_event += `${formatted_app}.page.load`;
  return traffic_event;
};

export const redirect_event = iframe => {
  const traffic_landing = iframe === 'true' ? 'in_iframe.' : 'sso_landing.';
  return `${traffic_landing}landing.redirect`;
};

export const no_pin_event = iframe => {
  return `${iframe === 'true' ? 'in_iframe.no_pin' : 'no_pin'}.page.load`;
};

export const capture_itc = url_params => {
  const itc = get_key_from_path(url_params, 'itc');
  return `landing.page_itc_${itc}.load`;
};
